import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://rswnatezaztzbfqjdvcv.supabase.co'
const SUPABASE_ANON_KEY = 'sb_publishable_xdC9TB89rL-7HbMc4bsfiw_kA7-oCwE'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
